// services/ocrActas/OcrEntregasService.js
import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const BASE = "/api/ocrActas";

// ---------- Registro sin OCR (no consume cuota Vision) ----------

export const preRegistrarOcr = async (rutas, oid_proyecto, confirmarReproceso = false) => {
  try {
    const response = await axios.post(`${baseUrl}${BASE}/preRegistrar`, {
      rutas,
      oid_proyecto,
      confirmarReproceso,
    });
    return response.data;
  } catch (error) {
    console.error("Error al registrar los archivos:", error);
    throw error;
  }
};

// ---------- Procesamiento con OCR (consume cuota Vision) ----------

export const procesarUnoOcr = async (oid, proveedor = "vision") => {
  try {
    const response = await axios.post(`${baseUrl}${BASE}/${oid}/procesar`, { proveedor });
    return response.data;
  } catch (error) {
    console.error("Error al procesar el acta:", error);
    throw error;
  }
};

export const procesarVariosOcr = async (oids, proveedor = "vision") => {
  try {
    const response = await axios.post(`${baseUrl}${BASE}/procesarVarios`, { oids, proveedor });
    return response.data;
  } catch (error) {
    console.error("Error al procesar las actas seleccionadas:", error);
    throw error;
  }
};

// ---------- Encabezado (ocr_entregas) ----------

export const listarOcrEntregas = async (oid_proyecto) => {
  try {
    const response = await axios.get(`${baseUrl}${BASE}/listar`, {
      params: { oid_proyecto },
    });
    return response.data;
  } catch (error) {
    console.error("Error al listar las entregas OCR:", error);
    throw error;
  }
};

export const listarOcrEntregasDetallado = async (oid_proyecto) => {
  try {
    const response = await axios.get(`${baseUrl}${BASE}/listarDetallado`, {
      params: { oid_proyecto },
    });
    return response.data;
  } catch (error) {
    console.error("Error al listar el detalle de las entregas OCR:", error);
    throw error;
  }
};

export const obtenerOcrEntrega = async (oid) => {
  try {
    const response = await axios.get(`${baseUrl}${BASE}/${oid}`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener la entrega OCR:", error);
    throw error;
  }
};

export const actualizarOcrEntrega = async (oid, datos) => {
  try {
    const response = await axios.put(`${baseUrl}${BASE}/${oid}`, datos);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar la entrega OCR:", error);
    throw error;
  }
};

export const crearActaManual = async (datos) => {
  try {
    const response = await axios.post(`${baseUrl}${BASE}/crearManual`, datos);
    return response.data;
  } catch (error) {
    console.error("Error al crear la acta manual:", error);
    throw error;
  }
};

export const vaciarProductosDeActa = async (oid) => {
  try {
    const response = await axios.delete(`${baseUrl}${BASE}/${oid}/soloProductos`);
    return response.data;
  } catch (error) {
    console.error("Error al vaciar los productos:", error);
    throw error;
  }
};

export const vaciarEncabezadoDeActa = async (oid) => {
  try {
    const response = await axios.delete(`${baseUrl}${BASE}/${oid}/soloEncabezado`);
    return response.data;
  } catch (error) {
    console.error("Error al vaciar el encabezado:", error);
    throw error;
  }
};

export const vaciarTodaLaActa = async (oid) => {
  try {
    const response = await axios.delete(`${baseUrl}${BASE}/${oid}/todo`);
    return response.data;
  } catch (error) {
    console.error("Error al vaciar la acta:", error);
    throw error;
  }
};

export const eliminarOcrEntrega = async (oid) => {
  try {
    const response = await axios.delete(`${baseUrl}${BASE}/${oid}`);
    return response.data;
  } catch (error) {
    console.error("Error al eliminar la entrega OCR:", error);
    throw error;
  }
};

export const eliminarVariasOcrEntregas = async (oids) => {
  try {
    const response = await axios.delete(`${baseUrl}${BASE}/eliminarVarios`, { data: { oids } });
    return response.data;
  } catch (error) {
    console.error("Error al eliminar las entregas OCR seleccionadas:", error);
    throw error;
  }
};

export const urlVerSoporte = (oid) => `${baseUrl}${BASE}/${oid}/soporte`;

// ---------- Productos (ocr_productos) ----------

export const listarProductosDeActa = async (oid) => {
  try {
    const response = await axios.get(`${baseUrl}${BASE}/${oid}/productos`);
    return response.data;
  } catch (error) {
    console.error("Error al listar los productos del acta:", error);
    throw error;
  }
};

export const crearProductoEnActa = async (oid, datos) => {
  try {
    const response = await axios.post(`${baseUrl}${BASE}/${oid}/productos`, datos);
    return response.data;
  } catch (error) {
    console.error("Error al crear el producto:", error);
    throw error;
  }
};

export const actualizarProductoOcr = async (oidProducto, datos) => {
  try {
    const response = await axios.put(`${baseUrl}${BASE}/productos/${oidProducto}`, datos);
    return response.data;
  } catch (error) {
    console.error("Error al actualizar el producto:", error);
    throw error;
  }
};

export const eliminarProductoOcr = async (oidProducto) => {
  try {
    const response = await axios.delete(`${baseUrl}${BASE}/productos/${oidProducto}`);
    return response.data;
  } catch (error) {
    console.error("Error al eliminar el producto:", error);
    throw error;
  }
};

export const copiarProductosOcrA = async (oidOrigen, oidsDestino) => {
  try {
    const response = await axios.post(`${baseUrl}${BASE}/${oidOrigen}/copiarProductosA`, { oids: oidsDestino });
    return response.data;
  } catch (error) {
    console.error("Error al copiar los productos a las actas destino:", error);
    throw error;
  }
};

// ---------- Catalogos / utilitarios ----------

export const obtenerUsoVision = async () => {
  try {
    const response = await axios.get(`${baseUrl}${BASE}/usoVision`);
    return response.data;
  } catch (error) {
    console.error("Error al obtener el uso de Vision:", error);
    throw error;
  }
};

export const buscarParticipantePorCedula = async (cedula) => {
  const response = await axios.get(`${baseUrl}${BASE}/buscarParticipante`, {
    params: { cedula },
  });
  return response.data;
};

export const buscarOrganizacionPorNit = async (nit) => {
  const response = await axios.get(`${baseUrl}${BASE}/buscarOrganizacion`, {
    params: { nit },
  });
  return response.data;
};

export const buscarProductos = async (oid_proyecto, q) => {
  const response = await axios.get(`${baseUrl}${BASE}/buscarProductos`, {
    params: { oid_proyecto, q },
  });
  return response.data;
};

export const listarProyectosOcr = async () => {
  const response = await axios.get(`${baseUrl}${BASE}/proyectos`);
  return response.data;
};
